import React, { FC, ReactNode } from "react";

import cn from "classnames";

import styles from "./OptionInfo.module.scss";

export interface OptionInfoProps {
  description: ReactNode;
  icon?: ReactNode;
  title: ReactNode;
}

const OptionInfo: FC<OptionInfoProps> = ({ description, icon, title }) => {
  return (
    <div className={cn(styles.container, { [styles.withIcon]: !!icon })}>
      {icon ? <div className={styles.icon}>{icon}</div> : null}
      <div className={styles.title}>{title}</div>
      <div className={styles.description}>{description}</div>
    </div>
  );
};

export default OptionInfo;
